'use strict';

require('../../helpers/guid/guid.service');

angular.module('far.models.userRelation', ['far.helpers.guid'])
.service('UserRelation', function(guid) {

    this.new = function(userData) {
      return new UserRelation(userData);
    };

    this.newUndefined = function(userRelation, userType) {
      var userData = {};
      userData[userRelation] = userType;

      return new UserRelation(userData);
    };

    function UserRelation(userData) {
      this.user = undefined;

      Object.defineProperty(this, 'uniqId', {
        enumerable: false,
        writable: false,
        value: guid()
      });

      Object.defineProperty(this, 'relation', {
        enumerable: false,
        writable: false,
        value: Object.keys(userData).filter(function(userKey) {
          return ['user', 'id'].indexOf(userKey) == -1;
        })[0]
      });

      angular.merge(this, userData);
    }

    UserRelation.prototype.toJSON = function() {
      if (!this.user || !this.user.id) {
        return undefined;
      }

      var jsonData = {
        user: this.user.id
      };
      jsonData[this.relation] = this[this.relation].id;
      if (this.id) {
        jsonData.id = this.id;
      }

      return jsonData;
    };
});
